/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentType } from './paymentType.model';
import { PaymentMethodCode } from './paymentMethodCode.model';


export interface SpecialPaymentDto { 
    account?: string;
    amount?: number;
    bankCode?: string;
    barterId?: number;
    contractId?: number;
    fullAccountNumber?: string;
    iban?: string;
    note?: string;
    /**
     * ID propachtovatele (vlastníka) na smlouvě, u SJM se jedná o ID SJM subjektu
     */
    ownerId?: number;
    paymentMethodCode?: PaymentMethodCode;
    paymentSubjectId?: number;
    specificSymbol?: string;
    subjectIdTo?: number;
    swift?: string;
    type?: PaymentType;
    variableSymbol?: string;
    withdrawPostage?: boolean;
    year?: number;
}
export namespace SpecialPaymentDto {
}


